export interface CustomerAttributeConstraint {
  type: string;
  code: string;
  description: string;

  displayValue: string;
}

export const EmptyCustomerAttributeConstraint = {
  type: "",
  code: "",
  description: "",
  displayValue: "",
} as CustomerAttributeConstraint;
